import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SousServiceService } from 'app/services/sous-Service/sous-service.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-liste-sous-service',
  templateUrl: './liste-sous-service.component.html',
  styleUrls: ['./liste-sous-service.component.scss']
})
export class ListeSousServiceComponent implements OnInit {
  public search: string = '';
  sousServices: any[] = [];
  filteredSousServices: any[] = [];

  constructor(
    private sousService: SousServiceService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.sousService.refreshNedeed.subscribe(() => {
      this.getData();
    });
    this.getData();
  }

  getData(): void {
    this.sousService.getListSousService().subscribe({
      next: (response: any) => {
        // ✅ CORRECTION CLÉ : s'assurer que data est bien un tableau
        let data = response;

        // Si la réponse est un objet avec une propriété contenant le tableau (ex: { data: [...] })
        if (Array.isArray(response)) {
          data = response;
        } else if (response && Array.isArray(response.data)) {
          data = response.data;
        } else if (response && Array.isArray(response.sous_services)) {
          data = response.sous_services;
        } else if (response && Array.isArray(response.list)) {
          data = response.list;
        } else {
          // Si aucune hypothèse ne marche, essayer de forcer en tableau
          console.warn('Format de réponse inattendu:', response);
          data = [];
        }

        this.sousServices = data;
        this.applyFilter();
      },
      error: (err) => {
        console.error('Erreur lors du chargement des sous-services:', err);
        Swal.fire({
          title: 'Erreur',
          text: 'Impossible de charger la liste des sous-services.',
          icon: 'error'
        });
      }
    });
  }

  applyFilter(): void {
    const filterValue = this.search.toLowerCase().trim();
    if (!filterValue) {
      this.filteredSousServices = [...this.sousServices];
    } else {
      this.filteredSousServices = this.sousServices.filter(item =>
        (item?.name && item.name.toLowerCase().includes(filterValue)) ||
        (item?.category && item.category.toLowerCase().includes(filterValue))
      );
    }
  }

  clearSearch(): void {
    this.search = '';
    this.applyFilter();
  }

  deletesousService(sousService: any): void {
    Swal.fire({
      title: 'Êtes-vous sûr(e) ?',
      text: 'Vous ne pourrez pas revenir en arrière !',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, supprimez-le !'
    }).then((result) => {
      if (result.isConfirmed) {
        this.sousService.deleteSousService(sousService.id).subscribe({
          next: () => {
            Swal.fire({
              title: 'Supprimé !',
              text: 'Le sous-service a été supprimé.',
              icon: 'success'
            });
            this.sousServices = this.sousServices.filter(s => s.id !== sousService.id);
            this.applyFilter();
          },
          error: (err) => {
            console.error('Erreur suppression:', err);
            Swal.fire({
              title: 'Erreur',
              text: 'La suppression a échoué. Veuillez réessayer.',
              icon: 'error'
            });
          }
        });
      }
    });
  }
}